import config from "../config";

export default {
  sendSMS() {
    return config.urlBase + "/sendSMS/index.php";
  },
  sendMail() {
    return config.urlBase + "/sendMail/index.php";
  },

  getDocumentPath(){
    return "./upload/membership";
  },

  createContract() {
    return config.urlBase + "/operations/createMembership.php";
  }
}


// WEBPACK FOOTER //
// ./src/common/Urls.js